import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ExpandedConfigurationSection, InputsActions } from "components/inputs/InputsOveriew";
import MessagesPerStreamSection from "components/inputs/InputsOveriew/expanded-sections/MessagesPerStreamSection";
import ExtractorsSection from "components/inputs/InputsOveriew/expanded-sections/ExtractorsSection";
import ExtractorsSectionActions from "components/inputs/InputsOveriew/expanded-sections/ExtractorsSectionActions";
import AssociatedStreamsSection from "components/inputs/InputsOveriew/expanded-sections/AssociatedStreamsSection";
import { METRIC_COLUMN_IDS, getMetricColumnTitle } from "components/inputs/InputsOveriew/metricColumns";
const useTableElements = ({
  inputTypeDescriptions,
  inputTypes
}) => {
  const { t } = useTranslation("inputs");
  const entityActions = useCallback(
    (listItem) => /* @__PURE__ */ React.createElement(InputsActions, { input: listItem, inputTypes, inputTypeDescriptions }),
    [inputTypes, inputTypeDescriptions]
  );
  const renderExpandedConfigurationDetails = useCallback(
    (input) => /* @__PURE__ */ React.createElement(ExpandedConfigurationSection, { input, inputTypeDescriptions }),
    [inputTypeDescriptions]
  );
  const expandedSections = useMemo(
    () => ({
      configuration: {
        title: t("overview.columns.configuration"),
        content: renderExpandedConfigurationDetails
      },
      [METRIC_COLUMN_IDS.messagesPerStream]: {
        title: getMetricColumnTitle(METRIC_COLUMN_IDS.messagesPerStream),
        content: (input) => /* @__PURE__ */ React.createElement(MessagesPerStreamSection, { input })
      },
      [METRIC_COLUMN_IDS.extractorCount]: {
        title: getMetricColumnTitle(METRIC_COLUMN_IDS.extractorCount),
        content: (input) => /* @__PURE__ */ React.createElement(ExtractorsSection, { input }),
        actions: (input) => /* @__PURE__ */ React.createElement(ExtractorsSectionActions, { input })
      },
      [METRIC_COLUMN_IDS.associatedStreams]: {
        title: getMetricColumnTitle(METRIC_COLUMN_IDS.associatedStreams),
        content: (input) => /* @__PURE__ */ React.createElement(AssociatedStreamsSection, { input })
      }
    }),
    [renderExpandedConfigurationDetails, t]
  );
  return {
    entityActions,
    expandedSections
  };
};
export default useTableElements;
